import { render, staticRenderFns } from "./MailEditor.vue?vue&type=template&id=3345113e"
import script from "./MailEditor.vue?vue&type=script&lang=js"
export * from "./MailEditor.vue?vue&type=script&lang=js"
import style0 from "./MailEditor.vue?vue&type=style&index=0&id=3345113e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports